import { Alert } from '@/components/ui/alert';
import { metaAdsBillingUrl } from '@/libs/meta-ads-links';
import { Button, Text, VStack } from '@chakra-ui/react';
import type { MentionBoostAdAccountDto } from '@fluenceur/types';
import { useTranslation } from 'react-i18next';

/**
 * Shown at launch time when the selected ad account has no payment method in
 * Meta. Choosing the account was allowed; spending on it is not, and the fix
 * lives in Meta's billing settings for that exact account, so the notice links
 * straight there instead of asking the marketer to go find it.
 */
export function AdAccountPaymentNotice({ account }: { account: MentionBoostAdAccountDto }) {
  const { t } = useTranslation();
  const billingUrl = metaAdsBillingUrl(account.id);

  return (
    <Alert
      status="warning"
      variant="surface"
      title={t('mentions.boost.setup.adAccount.paymentMissing.title')}
    >
      <VStack align="stretch" gap={2}>
        <Text>
          {t('mentions.boost.setup.adAccount.paymentMissing.description', {
            name: account.name,
          })}
        </Text>
        {billingUrl && (
          <Button asChild alignSelf="flex-start" size="sm" variant="outline" colorPalette="primary">
            <a href={billingUrl} target="_blank" rel="noopener noreferrer">
              {t('mentions.boost.setup.adAccount.paymentMissing.cta')}
            </a>
          </Button>
        )}
      </VStack>
    </Alert>
  );
}
